/**
 * Helpers de pluralisation (français/anglais).
 */

/**
 * Renvoie la forme singulière ou plurielle d'un mot selon le nombre.
 * @param {number} n
 * @param {string} singular
 * @param {string} [plural] - forme plurielle ; par défaut `singular + 's'`
 * @returns {string}
 */
export function plural(n, singular, plural) {
    return n > 1 ? plural || `${singular}s` : singular
}

/**
 * Construit un libellé du type « 3 réponses ».
 * @param {number} n
 * @param {string} singular
 * @param {string} [plural]
 * @returns {string}
 */
export function countLabel(n, singular, plural) {
    return `${n} ${plural(n, singular, plural)}`
}
